import { render, staticRenderFns } from "./RedirectAuth.vue?vue&type=template&id=285824df&scoped=true&"
import script from "./RedirectAuth.vue?vue&type=script&lang=js&"
export * from "./RedirectAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285824df",
  null
  
)

export default component.exports